import { render, staticRenderFns } from "./ProfileUpload.vue?vue&type=template&id=1808d94d&scoped=true"
import script from "./ProfileUpload.vue?vue&type=script&lang=js"
export * from "./ProfileUpload.vue?vue&type=script&lang=js"
import style0 from "./ProfileUpload.vue?vue&type=style&index=0&id=1808d94d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1808d94d",
  null
  
)

export default component.exports